<img *ngIf="logoUrl; else text"
     [src]="logoUrl"
     alt="Portal logo">

<ng-template #text>
  <span class="portal-name"
        [ngClass]="{'small': name.length >= 12, 'big': name.length < 12}">
    {{name}}
  </span>
</ng-template>